var _circle, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLmsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5713,
    r: 17.5,
    fill: "#474C5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0715 27.5713H22.9287C24.0332 27.5713 24.9287 26.6759 24.9287 25.5713V11.3342C24.9287 10.7575 24.6797 10.2089 24.2457 9.82909L22.2309 8.06614C21.8663 7.74713 21.3983 7.57129 20.9139 7.57129H12.0715C10.967 7.57129 10.0715 8.46672 10.0715 9.57129V25.5713C10.0715 26.6759 10.967 27.5713 12.0715 27.5713Z",
    fill: "#A1A3B2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5713,
    r: 5.5,
    fill: "#1D1E25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0686 19.5713V19.2588L16.0779 16.4609V16.4438H14.137V16.0483H16.6321V16.3608L14.6326 19.1587V19.1758H16.6736V19.5713H14.0686ZM17.6965 19.5713H17.2571V16.0483H17.6965V19.5713ZM18.3801 16.0483H19.6375C19.9679 16.0483 20.238 16.1541 20.448 16.3657C20.6596 16.5757 20.7654 16.8467 20.7654 17.1787C20.7654 17.5124 20.6596 17.785 20.448 17.9966C20.2364 18.2082 19.9646 18.314 19.6326 18.314H18.8196V19.5713H18.3801V16.0483ZM18.8196 16.439V17.9233H19.5227C19.7734 17.9233 19.9679 17.8582 20.1062 17.728C20.2445 17.5962 20.3137 17.4131 20.3137 17.1787C20.3137 16.9443 20.2445 16.7629 20.1062 16.6343C19.9695 16.5041 19.775 16.439 19.5227 16.439H18.8196Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLmsIcon);
export default __webpack_public_path__ + "static/media/lms_icon.d130aefd.svg";
export { ForwardRef as ReactComponent };